// noinspection ES6UnusedImports
import * as React from 'preact/compat'
import { hideToast, type ToastConfig } from '../toast'
import cn from 'classnames'
import { useSignal } from '@preact/signals'
import { useCallback, useEffect, useRef } from 'preact/compat'
import stalcraftCss from '../../../css/stalcraft.pcss.json'

export default ({
  config
}: {
  config: ToastConfig
}) => {
  if (!config.timeout && config.timeout !== 0) {
    config.timeout = 4000
  }
  const animationDuration = 500
  const timer = useSignal<number>(config.timeout)
  const isShown = useSignal<boolean>(false)
  const interval = useRef<number>()
  const resetTimer = useCallback(() => {
    clearInterval(interval.current)
    timer.value = config.timeout
  }, [interval.current, timer.value])
  const hideSelf = useCallback(() => {
    clearInterval(interval.current)
    isShown.value = false
    setTimeout(() => {
      hideToast(config.uuid)
    }, animationDuration)
  }, [interval.current, isShown.value, config.uuid])
  const startTimer = useCallback(() => {
    if (config.timeout === 0) {
      return
    }
    interval.current = setInterval(() => {
      timer.value -= 100
      if (timer.value <= 0) {
        hideSelf()
      }
    }, 100) as unknown as number
  }, [interval.current, timer.value, config.timeout])

  const handleClick = useCallback(() => {
    window.open('https://promo.stopgame.ru/stalcraft', '_blank')
    hideSelf()
  }, [hideSelf])

  useEffect(() => {
    isShown.value = true
    timer.value = config.timeout
    setTimeout(() => {
      startTimer()
    }, animationDuration)
  }, [config.timeout])

  const type = config.type.replace('stalcraft-', '')

  return <div
    className={cn(stalcraftCss['toast'], stalcraftCss[`toast--${type}`], {
      [stalcraftCss['toast--shown']]: isShown.value,
    })}
    onMouseOver={resetTimer}
    onMouseLeave={startTimer}
    onClick={handleClick}
  >
    <img className={stalcraftCss['toast__bg']} src='/img/stalcraft/toast-bg.png' alt=''/>
    <img className={stalcraftCss['toast__bg-glow']} src={`/img/stalcraft/toast-bg-glow-${type}.png`} alt=''/>
    <img className={stalcraftCss[`toast__character`]}
         src={`/img/stalcraft/toast-character-${type}.png`}
         alt=''
    />
    <div className={stalcraftCss[`toast__points-${type}`]}>
      +{config.score}
    </div>
    <div className={stalcraftCss['toast__content']}>
      <span>в команду</span>
      <div className={cn(stalcraftCss['toast__button'], stalcraftCss[`toast__button--${type}`])}>
        <span>{type === 'bandit' ? 'бандитов' : 'сталкеров'}</span>
        <div className={stalcraftCss['toast__button-squares1']}></div>
        <div className={stalcraftCss['toast__button-squares2']}></div>
      </div>
    </div>
  </div>
}
